import React from "react";
import ComponentsBreadcrumb from "../../layout/componentsBreadcrumb";
import BalanceViewComponent from "./balanceView";
import { Button, Col, Row } from "antd";
import MerchantComponent from "../dashboard.component/merchant/merchantcomponent";
import PaymentLinksComponent from "./PaymantLinks";
import TransactionComponent from "./transactions/transactioncomponent";
import { useHistory } from "react-router-dom";
const breadCrumbList = [
    { id: '1', bname: 'Payment Artha',url : '/dashboard' },
    { id: '2', bname: 'Dashboard' }
];
const DashboardComponent = () =>{
    const history = useHistory();

    const handleRedirect = () => {
        history.push('/createpaymentlink/create');
    };

    return (<>
    <div className="dashboard-breadcumb">
    <ComponentsBreadcrumb breadCrumbList={breadCrumbList} />
    </div>
    <BalanceViewComponent/>
    <Row gutter={[16, 16]} className="mt-30">
            <Col xs={24} sm={24} md={10} lg={8} xl={8} xxl={8}>
             <Button className="c-pointer btn-style payment-link" onClick={handleRedirect}><span>Create Payment Link</span><span className="icon lg right-arrow c-pointer"></span></Button>
           <MerchantComponent/>
      </Col>
        <Col xs={24} sm={24} md={14} lg={16} xl={16} xxl={16}>
         <PaymentLinksComponent/>
        </Col>
      </Row>
      <div className="mt-30">
        <TransactionComponent/>
      </div>
        </>
    )
}
export default DashboardComponent
